import { Discipline } from "../models/Master";
import { TabData } from "../models/TabSessionStorage";
import { getValue } from "../utils";

export const ICD10Title = "ADD ICD 10 CODES:";

export const ICD10DuplicateError =
  "Selected ICD10 code has already been added";

export const ICD10Text =
  "Please add ICD 10 codes by searching and adding codes to the below grid. One diagnosis code is mandatory.";

  export enum ICD10CodeType {
    PRIMARY = 1,
    SECONDARY = 2,
  }

  //Present in allpatient records file
  export interface InfoTable {
    diagnosisCode: string;
    diagnosisCodeDescription: string;
    diagnosisTypeId: number;
    diagnosisType: string;
    icdDiagnosisCodeId: number | null;
  }

  // Present in master.ts moved in this file as of now
  export interface DiseaseType {
    icdCode: string;
    icdDescription: string;
    icdDiagnosisCodeId: number;
  }
  
  export interface IcdDiseaseType {
    diagnosisCode: string;
    diagnosisCodeDescription: string;
    icdDiagnosisCodeId: number;
  }

  export interface IcdCodeType {
    diagnosisType: string;
    diagnosisTypeId: number;
  }

export enum IcdCodeTypeActionDispatchTypes {
  ICD_CODE_TYPE_INVOKE = "ICD_CODE_TYPE_INVOKE",
  ICD_CODE_TYPE_SUCCESS = "ICD_CODE_TYPE_SUCCESS",
  ICD_CODE_TYPE_ERROR = "ICD_CODE_TYPE_ERROR",
}

export enum DiseaseTypeActionDispatchTypes {
  DISEASE_TYPE_INVOKE = "DISEASE_TYPE_INVOKE",
  DISEASE_TYPE_SUCCESS = "DISEASE_TYPE_SUCCESS",
  DISEASE_TYPE_ERROR = "DISEASE_TYPE_ERROR",
}


export const getFormattedDisciplineData = (
  data: TabData,
  masterCareTypeState: Discipline[]
): { careTypeId: number; careTypeName: string }[] => {
  const careTypeId = getValue(data, "requestService.discipline");

  const finalArray = masterCareTypeState
    .filter((masterCareType: any) =>
      careTypeId.some(
        (careType: any) => careType.careTypeId === masterCareType.value
      )
    )
    .map((masterCareType: any) => {
      const matchingItem2 = careTypeId.find(
        (careType: any) => careType.careTypeId === masterCareType.value
      );
      return { careTypeId: matchingItem2.careTypeId, careTypeName: matchingItem2.careTypeName };
    });
  return finalArray;
};

export interface IcdCodesInfoDto {
  referralIcdCodeId: number;
  diagnosisTypeId: number;
  diagnosisCode: string;
  diagnosisCodeDescription: string;
  icdDiagnosisCodeId: number;
}

export interface IcdCodeForReAuth {
  id: number;
  typeId: number;
  fullNameCreated: string;
  icdCodesInfoDto: IcdCodesInfoDto[];
}

export enum ReAuthIcdCodeActionDispatchTypes {
  RE_AUTH_ICD_CODE_INVOKE = "RE_AUTH_ICD_CODE_INVOKE",
  RE_AUTH_ICD_CODE_SUCCESS = "RE_AUTH_ICD_CODE_SUCCESS",
  RE_AUTH_ICD_CODE_ERROR = "RE_AUTH_ICD_CODE_ERROR",
}